import { render, staticRenderFns } from "./Produce.vue?vue&type=template&id=4b804603"
import script from "./Produce.vue?vue&type=script&lang=js"
export * from "./Produce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports